import { Injectable, HostListener } from "@angular/core";
import {
	CanActivate,
	Router,
	ActivatedRouteSnapshot,
	RouterStateSnapshot,
	CanActivateChild,
} from "@angular/router";
import { AuthService } from "./auth.service";
import { Observable } from "rxjs";
import { appConfig } from "../../insaweb.config";

@Injectable()
export class AuthGuard implements CanActivate {
	constructor(
		private _authService: AuthService,
		private _router: Router,
	) {}

	canActivate(
		route: ActivatedRouteSnapshot,
		state: RouterStateSnapshot,
	): Observable<boolean> | boolean {
		console.info("location pathname:" + location.pathname);
		//if (location.pathname !== this._router.url && state.url !== '/login'  && !this._authService.isLoggedIn()) {
		//check if access token is provided as part of URL
		if (route.queryParamMap.has("accessToken")) {
			//TODO: validate token
			let token: string = route.queryParamMap.get("accessToken");
			this._authService.performAuthenticaton(token);
			this._authService.getUserInfo(true, true);
		}

		if (
			state.url !== "/login" &&
			location.pathname !== "/login" &&
			!this._authService.isLoggedIn()
		) {
			//if (state.url !== '/login'  && !this._authService.isLoggedIn()) {
			//window.location.href = '/login';
			this._router.navigate(["/login"]);
			//this._router.navigate(['/login'], {relativeTo: route} );
			return false;
		}
		// console.log('x:' + state.url)
		if (state.url === "/login" && this._authService.isLoggedIn()) {
			// this._router.navigate(['/home']);
			return false;
		}

		// try to track only when explicitly allowed OR it's not defined in config but through environment variable
		// if you run dev/build without using INSA_TRACKING the Google Analytics script is not being included
		if (
			(window["gtag"] && appConfig.allowTracking) ||
			(appConfig.allowTracking === undefined &&
				process.env.INSA_TRACKING === JSON.stringify(true))
		) {
			window["gtag"]("config", "UA-33079494-1", {
				page_title: state.url,
				page_location: window.location.href,
				page_path: state.url,
			});
		}
		const disabledRoutes = (appConfig as any).disabledRoutes as
			| string[]
			| undefined;
		const allowedGenericForms = (appConfig as any).allowedGenericForms as
			| string[]
			| undefined;
		// Watchlist is gated by a single config flag so that
		// disabling it also blocks direct URL access, not just the menu item.
		if (
			(appConfig as any).showWatchlist !== true &&
			state.url.startsWith("/controlTable")
		) {
			this._router.navigate(["/home"]);
			return false;
		}
		if (
			disabledRoutes &&
			disabledRoutes.some(
				(r) => state.url === r || state.url.startsWith(r + "?"),
			)
		) {
			this._router.navigate(["/home"]);
			return false;
		}
		if (
			allowedGenericForms &&
			allowedGenericForms.length > 0 &&
			allowedGenericForms[0] !== "All" &&
			state.url.startsWith("/genericForms")
		) {
			const match = state.url.match(/\/genericForms\/([^/?]+)/);
			const metadataName = match ? match[1] : null;
			if (metadataName && !allowedGenericForms.includes(metadataName)) {
				this._router.navigate(["/home"]);
				return false;
			}
		}

		return true;
	}

	/*canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean {
      if (state.url !== '/login' && !this._authService.isLoggedIn()) {
          this._router.navigate(['/login']);
          return false;
      }
      if (state.url === '/login' && this._authService.isLoggedIn()) {
        // this._router.navigate(['/home']);
        return false;
      }

      return true;
    }*/
}



// WEBPACK FOOTER //
// ./app/insa-services/auth.guard.ts